<template>
  <div v-if="isLoading" class="fixed inset-0 flex items-center justify-center z-50 bg-white/25 backdrop-blur-md">
    <div class="animate-spin rounded-full h-20 w-20 border-t-2 border-b-2 border-primary"></div>
  </div>
  <div v-else>
    <slot/>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: true,
    };
  },
  mounted() {
    setTimeout(() => {
      this.isLoading = false;
    }, 800); // Set the duration in milliseconds (2 seconds in this example)
  },
};
</script>

<style>
/* Customize the loader's appearance */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
}
</style>